module.exports = __webpack_public_path__ + "static/media/email-modal-image.81af6f68.png";